<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle">ソリューション</h1>
      <table class="l-form-table">
        <tr>
          <th class="v-middle"><span>ソリューション名</span></th>
          <td class="v-middle">
            <div class="l-inputAccount" style="width:100%;">
              <TextBox v-model="$v.solution.$model.name" @input="$v.solution.$touch()" />
            </div>
            <ValidationErrorMessage v-show="$v.solution.name.$error" validation="required" style="padding-left: 20px;" />
          </td>
        </tr>
        <tr>
          <th class="v-middle"><span>キャッチコピー</span></th>
          <td class="v-middle">
            <div class="l-inputAccount" style="width:100%;">
              <TextBox v-model="$v.solution.$model.catchCopy" @input="$v.solution.$touch()" />
            </div>
            <ValidationErrorMessage v-show="$v.solution.catchCopy.$error" validation="required" style="padding-left: 20px;" />
          </td>
        </tr>
        <tr>
          <th class="v-middle"><span>紹介文</span></th>
          <td class="v-middle">
            <div class="l-inputAccount" style="width:100%;">
              <TextArea v-model="$v.solution.$model.description" @input="$v.solution.$touch()" class="l-formGroup__textArea" />
            </div>
            <ValidationErrorMessage v-show="$v.solution.description.$error" validation="required" style="padding-left: 20px;" />
          </td>
        </tr>
        <tr>
          <th class="v-middle"><span>紹介文&nbsp;(一覧用)</span></th>
          <td class="v-middle">
            <div class="l-inputAccount" style="width:100%;">
              <TextArea v-model="$v.solution.$model.descriptionForList" @input="$v.solution.$touch()" class="l-formGroup__textArea" />
            </div>
            <ValidationErrorMessage v-show="$v.solution.descriptionForList.$error && !$v.solution.descriptionForList.required" validation="required" style="padding-left: 20px;" />
            <ValidationErrorMessage v-show="$v.solution.descriptionForList.$error && !$v.solution.descriptionForList.maxLength" validation="maxLength" valueLength="90" style="padding-left: 20px;" />
          </td>
        </tr>
        <tr>
          <th class="v-middle"><span>紹介ページURL</span></th>
          <td class="v-middle">
            <div class="l-inputAccount" style="width:100%;">
              <TextBox v-model="$v.solution.$model.introductionPageUrl" @input="$v.solution.$touch()" />
            </div>
            <ValidationErrorMessage v-show="$v.solution.introductionPageUrl.$error" validation="url" style="padding-left: 20px;" />
          </td>
        </tr>
        <tr>
          <th class="v-middle"><span>問合せページURL</span></th>
          <td class="v-middle">
            <div class="l-inputAccount" style="width:100%;">
              <TextBox v-model="$v.solution.$model.contactUrl" @input="$v.solution.$touch()" />
            </div>
            <ValidationErrorMessage v-show="$v.solution.contactUrl.$error" validation="url" style="padding-left: 20px;" />
          </td>
        </tr>
        <tr>
          <th class="v-middle"><span>画像イメージ</span></th>
          <td class="v-middle">
            <div v-if="!this.solutionId">
              <span style="padding-left: 20px;">画像はソリューション登録後に設定できます。</span>
            </div>
            <div v-else>
              <img :src="file.url" alt="" style="padding-left: 20px; max-width: 100%; height: auto; width /***/:auto;">
              <br />
              <span style="padding-left: 20px;">{{ file.fileNm }}</span>
              <input style="padding-left: 20px;" type="file" v-on:change="fileSelected">
              <br />
              <div class="btn-basic is-small is-inlne" @click="fileUpload()"><a>アップロード</a></div>
              <div class="btn-basic is-small is-inlne" @click="fileDelete()"><a>ファイル削除</a></div>
            </div>
          </td>
        </tr>
        <tr>
          <th class="v-middle"><span>資料</span></th>
          <td class="v-middle">
            <div v-if="!this.solutionId">
              <span style="padding-left: 20px;">資料はソリューション登録後に設定できます。</span>
            </div>
            <div v-else>
              <span style="padding-left: 20px;" @click="download(documentFile.url, documentFile.fileNm)">
                {{ documentFile.fileNm }}
              </span>
              <input type="file" style="padding-left: 20px;" v-on:change="documentFileSelected">
              <br />
              <div class="btn-basic is-small is-inlne" @click="documentFileUpload()"><a>アップロード</a></div>
              <div class="btn-basic is-small is-inlne" @click="documentFileDelete()"><a>ファイル削除</a></div>
            </div>
          </td>
        </tr>
        <tr>
          <th class="v-middle"><span>非表示</span></th>
          <td class="v-middle">
            <label class="l-checkbox">
              <CheckBox v-model="$v.solution.$model.isInvisible" :value="true" :checked="solution.isInvisible" labelText="非表示" />
            </label>
          </td>
        </tr>
      </table>
      <div class="l-contentsBox__bottom" style="text-align: center;">
        <div class="btn-basic is-inlne is-primary js-savebtn" @click="register()"><a>保存</a></div>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import TextBox from '@/components/parts/form/TextBox.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import CheckBox from '@/components/parts/form/CheckBox.vue';
import { required, url, maxLength } from 'vuelidate/lib/validators';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import { saveAs } from "file-saver";

export default {
  components: {
    Loading,
    TextBox,
    TextArea,
     CheckBox,
    ValidationErrorMessage,
  },
  data() {
    return {
      isProcessing: false,
      solution: {
        name: '',
        catchCopy: '',
        description: '',
        descriptionForList: '',
        introductionPageUrl: '',
        contactUrl: '',
        isInvisible: false,
      },
      file: {
        fileNm: '',
        filePath: '',
        url: '',
      },
      fileInfo: '',
      documentFile: {
        fileNm: '',
        filePath: '',
        url: '',
      },
      documentFileInfo: '',
    }
  },
  validations: {
    solution: {
      name: { required },
      catchCopy: { required },
      description: { required },
      descriptionForList: { required, maxLength: maxLength(90) },
      introductionPageUrl: { url },
      contactUrl: { url },
      isInvisible: { required },
    }
  },
  computed: {
    solutionId() {
      return this.$store.getters['master/getSolutionId'];
    },
    fileName() {
      return this.file ? this.file.fileNm : '';
    }
  },
  created: function () {
    if (this.$route.name === 'solution-master-edit') {
      this.getSolution(this.solutionId);
    }
  },
  methods: {
    async getSolution(solutionId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/solution/getSolution', {
        solutionId: solutionId
      });
      if (res) {
        this.solution = res.data.solution;
        this.file = res.data.file;
        this.documentFile = res.data.documentFile;
      }
      this.isProcessing = false;
    },
    async register() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.isProcessing = true;
        let res = await this.$axios.post('/ld/api/master/solution/store', {
          solution: this.solution,
        });
        if (res.status === 200) {
          this.$store.dispatch('alert/setMessage', '登録が完了しました');
          this.$store.dispatch('master/setSolutionId', null);
          this.$router.push({ name: 'solution-master-list' });
        } else {
          this.$toast.error(res.data.message);
        }
        this.isProcessing = false;
      }
    },
    fileSelected(event) {
      this.fileInfo = event.target.files[0];
    },
    async fileUpload() {
      this.isProcessing = true;
      if (!this.fileInfo) {
        this.$toast.error("ファイルを選択してください");
        this.isProcessing = false;
        return;
      }
      const formData = new FormData();
      formData.append('file', this.fileInfo);
      formData.append('solutionId', this.solutionId);
      let res = await this.$axios.post('/ld/api/master/solution/uploadImageFile', formData);
      if (res.status === 200) {
        this.$toast.info('画像の登録が完了しました');
        this.getSolution(this.solutionId);
      } else {
        this.$toast.error(res.data.message);
      }
      this.fileInfo = '';
      this.isProcessing = false;
    },
    async fileDelete() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/solution/deleteImageFile', {
        solutionId: this.solutionId,
      });
      if (res.status === 200) {
        this.$toast.info('画像の削除が完了しました');
        this.getSolution(this.solutionId);
      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },

    documentFileSelected(event) {
      this.documentFileInfo = event.target.files[0];
    },
    async documentFileUpload() {
      this.isProcessing = true;
      if (!this.documentFileInfo) {
        this.$toast.error("ファイルを選択してください");
        this.isProcessing = false;
        return;
      }
      const formData = new FormData();
      formData.append('documentFile', this.documentFileInfo);
      formData.append('solutionId', this.solutionId);
      let res = await this.$axios.post('/ld/api/master/solution/uploadDocumentFile', formData);
      if (res.status === 200) {
        this.$toast.info('資料ファイルの登録が完了しました');
        this.getSolution(this.solutionId);
      } else {
        this.$toast.error('資料ファイル登録時にエラーが発生しました');
      }
      this.documentFileInfo = '';
      this.isProcessing = false;
    },
    async documentFileDelete() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/solution/deleteDocumentFile', {
        solutionId: this.solutionId,
      });
      if (res.status === 200) {
        this.$toast.info('資料ファイルの削除が完了しました');
        this.getSolution(this.solutionId);
      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },
    async download(url, fileName) {
      this.isProcessing = true;
      await saveAs(url, fileName);
      this.isProcessing = false;
    },
  }
}

</script>
